import { render, staticRenderFns } from "./UserSuspendButton.vue?vue&type=template&id=9ff811c4&"
import script from "./UserSuspendButton.vue?vue&type=script&lang=js&"
export * from "./UserSuspendButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports